import script from "./login.vue?vue&type=script&setup=true&lang=js"
export * from "./login.vue?vue&type=script&setup=true&lang=js"

import "./login.vue?vue&type=style&index=0&id=534180d2&scoped=true&lang=less"

import exportComponent from "/Users/baron/Desktop/New-OnlineServiceCenter/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-534180d2"]])

export default __exports__